module.exports = __webpack_public_path__ + "static/media/015.1ec7f43c.jpg";